export async function shareOrCopy(shareData) {
    if (canUseNativeShare(shareData)) {
        try {
            await navigator.share(shareData);
            return 'shared';
        } catch (error) {
            if (error.name === 'AbortError') {
                return 'aborted';
            }
        }
    }

    await copyToClipboard(shareData.url);
    return 'copied';
}

export function canUseNativeShare(shareData) {
    if (! navigator.share) {
        return false;
    }

    if (! navigator.canShare) {
        return true;
    }

    try {
        return navigator.canShare(shareData);
    } catch (error) {
        return true;
    }
}

export async function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
    }

    const $textarea = document.createElement('textarea');
    $textarea.value = text;
    $textarea.setAttribute('readonly', 'readonly');
    $textarea.style.position = 'fixed';
    $textarea.style.top = '-999px';
    document.body.appendChild($textarea);
    $textarea.select();
    document.execCommand('copy');
    document.body.removeChild($textarea);

    return Promise.resolve();
}
